import request from 'api/request';

export default function destroyCourse(id) {
  return request({ url: `/courses/${id}`, method: 'DELETE' });
}
